import { createSlice } from "@reduxjs/toolkit";
import {
  LeadDataDTO,
  HeaderLead,
  LeadCustomFieldDTO,
  Project,
} from "../../models/Lead.model";
import {
  getLeadData,
  getLeads,
  getLeadsConfig,
  setLeadsConfig,
} from "../thunks/leadThunks";
import { getProjectHeader } from "../thunks/projectHeaderThunks";
import { updateProjectComments } from "../thunks/projectThunks";

interface LeadState {
  leads: Project[];
  header: HeaderLead | null;
  leadData: LeadDataDTO | null;
  leadsConfig: LeadCustomFieldDTO[];
  loading: boolean;
  configLoading: boolean;
  error: string | null;
  configError: string | null;
}

const initialState: LeadState = {
  leads: [],
  header: null,
  leadData: null,
  leadsConfig: [],
  loading: false,
  configLoading: false,
  error: null,
  configError: null,
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    clearLeadError(state) {
      state.error = null;
    },
    clearLeads(state) {
      state.leads = [];
    },
    clearConfigError(state) {
      state.configError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLeads.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLeads.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.leads) {
          state.leads = action.payload.leads.projects || [];
          state.header = action.payload.leads.header || null;
        } else {
          state.leads = [];
          state.header = null;
        }
      })
      .addCase(getLeads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה בקבלת הערות";
      })
      .addCase(getLeadData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLeadData.fulfilled, (state, action) => {
        state.loading = false;
        state.leadData = action.payload.lead;
      })
      .addCase(getLeadData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה בקבלת הערות";
      })
      .addCase(getLeadsConfig.pending, (state) => {
        state.configLoading = true;
        state.configError = null;
      })
      .addCase(getLeadsConfig.fulfilled, (state, action) => {
        state.configLoading = false;
        state.leadsConfig = action.payload.customFields;
      })
      .addCase(getLeadsConfig.rejected, (state, action) => {
        state.configLoading = false;
        state.configError = action.payload || "שגיאה בקבלת הגדרות השדות";
      })
      .addCase(setLeadsConfig.pending, (state) => {
        state.configLoading = true;
        state.configError = null;
      })
      .addCase(setLeadsConfig.fulfilled, (state) => {
        state.configLoading = false;
      })
      .addCase(setLeadsConfig.rejected, (state, action) => {
        state.configLoading = false;
        state.configError = action.payload || "שגיאה בעדכון הגדרות השדות";
      })
      .addCase(getProjectHeader.fulfilled, (state, action) => {
        // עדכון leadData עם הנתונים החדשים מ-getProjectHeader
        if (state.leadData && action.payload.projectHeaderDTO) {
          // יצירת אובייקט חדש כדי להבטיח re-render
          state.leadData = {
            ...state.leadData,
            tasksIconStatus:
              action.payload.projectHeaderDTO.tasksIconStatus ??
              state.leadData.tasksIconStatus,
            appointmentsIconStatus:
              action.payload.projectHeaderDTO.appointmentsIconStatus ??
              state.leadData.appointmentsIconStatus,
          };
        }
      })
      .addCase(updateProjectComments.fulfilled, (state, _action) => {
        // עדכון ההערות ב-leadData אחרי שמירה מוצלחת
        if (state.leadData) {
          // רענון leadData מהשרת או עדכון ישיר
          // אם יש צורך לרענן מהשרת, כאן צריך לקרוא ל-getLeadData שוב
        }
      });
  },
});

export const { clearLeadError, clearLeads, clearConfigError } =
  leadSlice.actions;
export default leadSlice.reducer;
